import { NoSearchYetState } from '@/app/components/EmptyState/NoSearchYetState';
import { NothingFoundState } from '@/app/components/EmptyState/NothingFoundState';
import { Spinner } from '@/app/components/Spinner';
import { MIN_SEARCH_LENGTH } from '@/consts/search-const';
import type { Maybe } from '@/types/common';
import type { GlobalSearchData } from '@/types/globalSearchApiTypes';
import { SearchCategories } from '../SearchCategories';

interface SearchResultsPanelProps {
  categories: Maybe<GlobalSearchData>;
  isLoading: boolean;
  query: string;
  className?: string;
}

export const SearchResultsPanel = ({ categories, isLoading, query, className }: SearchResultsPanelProps) => {
  const hasResults = !!categories && Object.values(categories).some((category) => category.results.length > 0);

  const showNoSearchYet = query.length < MIN_SEARCH_LENGTH && !isLoading;
  const showNothingFound = query.length >= MIN_SEARCH_LENGTH && !isLoading && !hasResults;

  return (
    <div className={className}>
      {isLoading && (
        <div className="flex items-center justify-center py-10">
          <Spinner />
        </div>
      )}
      {!isLoading && categories && <SearchCategories categories={categories} />}
      {showNoSearchYet && (
        <div className="flex flex-1 items-center justify-center md:py-12">
          <NoSearchYetState />
        </div>
      )}
      {showNothingFound && (
        <div className="flex flex-1 items-center justify-center md:py-12">
          <NothingFoundState />
        </div>
      )}
    </div>
  );
};
